import React from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import { withContainerWrapper } from '../ContainerWrapper';
import catalogueActions from '../../actions/catalogue/catalogue/index.ts';
import * as utils from '../../utils/Utils';
import { getSelectedItems } from '../../selectors/catalogue/catalogueSelector';
import { brandAccDefaultValues } from '../../selectors/default_values/defaultValuesSelector';

class CounterContainer extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.updateCounter > this.props.updateCounter) {
      this.debouncedUpdate();
    }
    if (utils.itemsChanged(this.props.selectedItems, nextProps.selectedItems)) {
      if (this.props.updateCounter !== 0) {
        this.debouncedUpdate.cancel();
      }
    }
  }

  handleCounterExpired = () => {
    const { selectedItems, selectedItem, activeArea, defaultValues } = this.props;
    if (selectedItems.length > 0) {
      const langId = defaultValues.find(d => d.resource_table === 'languages')?.value;
      this.props.dispatch(
        catalogueActions.fetchItemsDataAfterUpdate(selectedItems, selectedItem, activeArea, langId)
      );
    }
  };

  // Note: If leading and trailing options are true, func is invoked on the trailing edge of the
  // timeout only if the debounced function is invoked more than once during the wait timeout.
  debouncedUpdate = debounce(this.handleCounterExpired, 2000, { leading: true, trailing: true });

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  const selectedItems = getSelectedItems(state);
  return {
    selectedItems,
    selectedItem: selectedItems[0],
    activeArea: state.app.navigationBar.activeArea,
    updateCounter: state.catalogue.updateManager.updateCounter,
    defaultValues: brandAccDefaultValues(state),
  };
}
export default connect(mapStateToProps)(withContainerWrapper(CounterContainer));
